/**
 * BattleCode Demo v1.0.0 — ERROR 错误码常量表
 *
 * GDD §13.7 LOCK 2026-07-04:7 个 demo 阶段锁定错误码,4 位十六进制
 * 屏 5 顶状态栏 [ERROR] · 0xXXXX 红高亮 1.5s → 灰显常驻 + KILL FEED 同步插一条
 *
 * 码段分配(避免冲突):
 *   0x5E00-0x5E0F  Think 异常   玩家 think() 异常      警告(可继续)
 *   0x5E10-0x5E1F  AI 异常      AI 行为引擎异常        警告(可继续)
 *   0x5E20-0x5E2F  渲染异常     地图/资源/动画加载      错误(继续但画面可能坏)
 *   0x5E30-0x5E3F  引擎异常     tick loop / 状态机      严重(中断战斗)
 *   0x5E40-0x5E4F  网络异常     录像保存/分享(预留)     信息
 *   0x5E50-0x5EFF  预留         v1+ 扩展                -
 */

export const ERROR_CODES = {
  // ===== Think 异常 (0x5E00-0x5E0F) =====
  /** 玩家 think() 抛未捕获异常 */
  THINK_EXCEPTION: "0x5E03",
  /** think() 执行 > 50ms (§6.2 锁软超时) */
  THINK_TIMEOUT: "0x5E04",
  /** think() 步数 > 10000(Pyodide 死循环检测) */
  THINK_INFINITE_LOOP: "0x5E05",

  // ===== AI 异常 (0x5E10-0x5E1F) =====
  /** AI 规则定义 JSON 解析失败 */
  AI_RULE_INVALID: "0x5E10",
  /** AI 4 条规则全 0 概率 */
  AI_RULE_EMPTY: "0x5E11",

  // ===== 渲染异常 (0x5E20-0x5E2F) =====
  /** 地图/资源加载失败 */
  RENDER_ASSET_MISSING: "0x5E20",

  // ===== tick 异常 (0x5E30-0x5E3F) =====
  /** tick loop 状态机损坏 */
  TICK_LOOP_CORRUPTED: "0x5E30",

  // ===== Phase 3: 裁判违规 (0x5E06-0x5E07) =====
  /** 动作被裁判拦截（API 白名单/非法类型） */
  ACTION_BLOCKED: "0x5E06",
  /** 规则违反（cooldown/超距等被裁判记录） */
  RULE_VIOLATION: "0x5E07",
} as const;

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];

/** 玩家看到错误码时的修复建议(GDD §13.7 表第 4 列) */
export const ERROR_HINTS: Record<string, string> = {
  [ERROR_CODES.THINK_EXCEPTION]: "检查代码语法/逻辑,看 CONSOLE 输出",
  [ERROR_CODES.THINK_TIMEOUT]: "简化 think() 逻辑,加 scan 缓存",
  [ERROR_CODES.THINK_INFINITE_LOOP]: "检查 while/for 循环",
  [ERROR_CODES.AI_RULE_INVALID]: "(玩家不可改 AI 代码,仅观察)",
  [ERROR_CODES.AI_RULE_EMPTY]: "(同上)",
  [ERROR_CODES.RENDER_ASSET_MISSING]: "刷新页面",
  [ERROR_CODES.TICK_LOOP_CORRUPTED]: "(只能刷新页面)",
  [ERROR_CODES.ACTION_BLOCKED]: "该 API 在当前关卡被禁用",
  [ERROR_CODES.RULE_VIOLATION]: "动作违反规则(冷却/超距等)",
};
